import { Component, ViewChild } from '@angular/core';
import { ActivationBaseComponent } from '@src/base-components/activation/activation.component';
import { ActivationSelectRetailerComponent } from '@src/base-components/activation/steps/select-retailer/activation-select-retailer';
import { ActivationSelectTypeComponent } from '@src/base-components/activation/steps/select-type/activation-select-type';
import { ActivationFindSNWCComponent } from '@src/base-components/activation/steps/find-wc/activation-find-sn-wc';
import { ActivationCustomerCreationOrisComponent } from './steps/customer/activation-customer-creation';

@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss']
})
export class ActivationComponent extends ActivationBaseComponent {

  @ViewChild(ActivationSelectRetailerComponent) activationSelectRetailerComponent: ActivationSelectRetailerComponent;
  @ViewChild(ActivationSelectTypeComponent) activationSelectTypeComponent: ActivationSelectTypeComponent;
  @ViewChild(ActivationFindSNWCComponent) activationFindSNWCComponent: ActivationFindSNWCComponent;
  @ViewChild(ActivationCustomerCreationOrisComponent) activationCustomerCreationOrisComponent: ActivationCustomerCreationOrisComponent;


  resetToStep0() {
    this.activationSelectRetailerComponent.reset();
    this.activationCustomerCreationOrisComponent.setDefaultValues();
    this.resetToStep1();
  }

  resetToStep1() {
    this.activationFindSNWCComponent.reset();
    this.resetToStep2();
  }

  resetToStep2() {
    if (this.activationCustomerCreationOrisComponent == undefined) {
      this.validationErrors = [];
    }
    this.resetToStep3();
  }

  resetToStep3() {
      this.validationErrors = [];
  }
}
